module.exports = __webpack_public_path__ + "img/PH.62b10c25.svg";